/**
 *  Stores 
 */
export  const appSetting = {
    localStorage: {
        lang : "comprodls.nemo.selected-locale",
        cookiesAccepted : "comprodls.nemo.cookiesAccepted",
        adminSelectedView: "comprodls.nemo.admin.selectedView-user.",
        userLoggedOut: "comprodls.nemo.userLoggedOut",
        messageBanner : "comprodls.nemo.messageBanner.",
        lastReadCommentTimestamp : "comprodls.nemo.collab-task.readTs",
        loggedInUserRole: "comprodls.nemo.loggedInUserRole",
        dashboard: (userid: string) => "comprodls.nemo.user." + userid + ".dashboard",
        assignmentOnlyComponentBanner: (userid: string) => "comprodls.nemo.user." + userid + ".assignmentOnlyComponentBanner"
    },
    sessionStorage: {
        userAccount : "comprodls.nemo.userAccount"
    }
}